import React, { useRef, useState } from "react";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { FileUpload } from "primereact/fileupload";
import { Tooltip } from "primereact/tooltip";
import { Toast } from 'primereact/toast';
import { Image } from "primereact/image";
import { handlePostRequest } from "../../../services/PostTemplate";

const CNIC = () => {
    const [frontImage, setFrontImage] = useState("");
    const [backImage, setBackImage] = useState("");
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const userId = useSelector((state) => state.authenticationSlice?.userId)
    const history = useHistory();
    const dispatch = useDispatch();
    const toast = useRef(null);
    const [totalSize, setTotalSize] = useState(0);
    const fileUploadFrontRef = useRef(null);
    const fileUploadBackRef = useRef(null);

    const validationSchema = Yup.object().shape({
        type: Yup.mixed().required("This field is required."),
        frontImage: Yup.mixed().required("This field is required."),
        backImage: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        // validationSchema: validationSchema,
        initialValues: {
            userId: "",
            documents: {
                type: "cnic",
                frontImage: "",
                backImage: ""
            }
        },

        onSubmit: async (data) => {
            let payload = {
                userId: userId,
                documents: {
                    type: "cnic",
                    frontImage: frontImage,
                    backImage: backImage
                }
            };
            console.log(payload, "pay")
            try {
                setSaveBtnLoading(true);
                const response = await dispatch(handlePostRequest("api/user/uploadDocument", payload, true, true))
                // const response = await Axios.post(`${baseURL}/api/user/uploadDocument`,encryptPayload, true,true);
                formik.resetForm();
                setSaveBtnLoading(false);
                return response

            }
            catch (error) {
                console.error(error)
                setSaveBtnLoading(false);
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };
    const onTemplateSelect = (e, type) => {
        let _totalSize = totalSize;
        let file = e.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Image = reader.result;

                if (type === "front") {
                    setFrontImage(base64Image);
                } else if (type === "back") {
                    setBackImage(base64Image);
                }
            };
            reader.readAsDataURL(file);
        }

        _totalSize += file.size || 0;
        setTotalSize(_totalSize);
    };
    const onTemplateUpload = (e) => {
        if (e && e.files) {
            let _totalSize = 0;
            e.files.forEach((file) => {
                _totalSize += file.size || 0;
            });
            setTotalSize(_totalSize);
            toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
        }
    };
    const onTemplateRemove = (file, callback) => {
        setTotalSize(totalSize - file.size);
        callback();
    };

    const onTemplateClear = () => {
        setTotalSize(0);
    };


    const headerTemplate = (options) => {
        const { className, chooseButton, cancelButton } = options;
        // const value = totalSize / 10000;
        // const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {/* {cancelButton} */}
                <div className="flex align-items-center gap-3 ml-auto">
                    {/* <span>{formatedValue} / 1 MB</span> */}
                    {/* <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar> */}
                </div>
            </div>
        );
    };


    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap" style={{ position: 'relative', justifyContent: 'center', }}>
                <div className="flex justify-content-center align-items-center" >
                    <Image alt={file.name} role="presentation" src={file.objectURL} width="100%" style={{ marginTop: "1rem" }} />
                </div>
                <Button
                    type="button"
                    icon="pi pi-times"
                    className="p-button-outlined p-button-rounded p-button-danger"
                    style={{
                        position: "absolute",
                        top: "-15px",
                        right: " -5px",
                        padding: "1rem",
                        fontSize: "0.5rem",
                        width: "24px",
                        height: "24px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => onTemplateRemove(file, props.onRemove)}
                />
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column xl:p-0 lg:p-0 md:p-3 sm:p-0">
                <i className="pi pi-image mt-1 xl:mt-3 lg:mt-3 md:mt-3 sm:mt-3 p-3 xl:p-4 lg:p-2 md:p-1 sm:p-3 text-base xl:text-4xl lg:text-4xl md:text-4xl sm:text-4xl" style={{ fontSize: '2rem', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2rem', color: 'var(--text-color-secondary)' }} className="text-sm xl:text-xl lg:text-xl md:text-xl sm:text-xl my-0 xl:my-3 lg:my-3 md:my-3 sm:my-3">
                    Drag and Drop Image Here
                </span>
            </div>
        );
    };

    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined text-white' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: '  p-button-rounded p-button-outlined text-white' };

    return (
        <>
            <div className="">

                <div className='flex justify-content-center' style={{ gap: "3rem" }}>

                    <form className="doc-form" onSubmit={formik.handleSubmit}>
                        <div className="w-full surface-card py-4 px-4 ">
                            <h4 className='text-white mb-4'>CNIC Documents</h4>
                            <div className=" grid justify-content-center">
                                <div className="col-12 xl:col-6 lg:col-6 md:col-6 sm:col-12">
                                    <h4 className="text-base xl:text-xl lg:text-xl md:text-xl sm:text-xl">Front Image</h4>
                                    <Toast ref={toast}></Toast>
                                    <Tooltip target="" content="Choose" position="bottom" />

                                    <FileUpload
                                        ref={fileUploadFrontRef}
                                        name="demo[]"
                                        url="/api/upload"
                                        accept="image/*"
                                        mode="advanced"
                                        onChange={onTemplateUpload}
                                        onSelect={(e) => onTemplateSelect(e, "front")}
                                        onError={onTemplateClear}
                                        onClear={onTemplateClear}
                                        headerTemplate={headerTemplate}
                                        itemTemplate={itemTemplate}
                                        emptyTemplate={emptyTemplate}
                                        chooseOptions={chooseOptions}
                                    />
                                </div>
                                <div className="col-12 xl:col-6 lg:col-6 md:col-6  sm:col-12">
                                    <h4 className="text-base xl:text-xl lg:text-xl md:text-xl sm:text-xl">Back Image</h4>
                                    <Toast ref={toast}></Toast>
                                    <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
                                    <FileUpload
                                        ref={fileUploadBackRef}
                                        name="demo[]"
                                        url="/api/upload"
                                        mode="advanced"
                                        accept="image/*"
                                        onChange={onTemplateUpload}
                                        onSelect={(e) => onTemplateSelect(e, "back")}
                                        onError={onTemplateClear}
                                        onClear={onTemplateClear}
                                        headerTemplate={headerTemplate}
                                        itemTemplate={itemTemplate}
                                        emptyTemplate={emptyTemplate}
                                        chooseOptions={chooseOptions}
                                    />
                                    {/* <Toast ref={toast}></Toast>

                                    <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
                                    <Tooltip target="." content="Clear" position="bottom" />

                                    <FileUpload ref={fileUploadRef} name="demo[]" url="/api/upload" accept="image/*" 
                                        onUpload={onTemplateUpload} onSelect={onTemplateSelect} onError={onTemplateClear} onClear={onTemplateClear}
                                        headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate}
                                        chooseOptions={chooseOptions} cancelOptions={cancelOptions} /> */}
                                </div>
                            </div>
                            <div className="">
                                <Button label="Upload" loading={saveBtnLoading} type="submit" className="block font-medium mx-auto mt-3 xl:mt-5 lg:mt-5 md:mt-5 sm:mt-5 text-lg w-9rem" />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default CNIC